import React, { useState, useEffect } from "react";
import "./FormStyles.css";
import { handle_service, mailforthemeet, sendFormEmail } from "../../utils/services";
import { submitToAWS } from "../../utils/payment_fetch";
import ThankYouStep from "../../components/payment/thankyyoupage";
import { handle_tools_services } from "../../utils/services";
import whatsappIcon from "../../assets/images/socialIcons/wpLogo.png";
import { prod_aws_payment } from "../../utils/payment_fetch";
import { meetAndMail } from "../../utils/meet_mail";
import { putData, updateData } from "../../utils/awsService";
const FamilyTherapyForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 6;
  const [errors, setErrors] = useState({});
  const [autoNextEnabled, setAutoNextEnabled] = useState(true);
  const [stepsAttempted, setStepsAttempted] = useState({});
  const [database_response, setdatabase_response] = useState({});
  useEffect(() => {
    if (database_response?.data?.id) {
      console.log("Updated ID:", database_response.data.id);

      // ✅ Optional: call a function with the ID
      // yourOtherFunction(databaseResponse.data.id);
    }
  }, [database_response]);
  // Create useState for form data instead of useRef to trigger re-renders
  let [formData, setFormData] = useState({
    name: "",
    email: "",
    gender: "",
    city: "",
    contactNo: "",
    guardianContactNo: "",
    profession: "",
    age: "",
    supportReason: [],
    otherSupportReason: "",
    feelingsReason: "",
    previousConsultation: "",
    preferredLanguage: "",
    otherLanguage: "",
    sessionDate: "",
    sessionTime: "",
    counselorGenderPreference: "",
    medicalConditions: "",
    referralSource: "",
    termsAgreed: false,
    PaymentsAgreed: false,
    sessionDuration: "",
  });

  // Helper function to convert 12-hour format to 24-hour format
  const convertTo24Hour = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}:00`;
  };

  // Helper function to add duration to time
  const addMinutesToTime = (dateTimeString, minutes) => {
    const date = new Date(dateTimeString);
    date.setMinutes(date.getMinutes() + minutes);
    return date.toISOString();
  };

  // Function to create meeting data from form
  const createMeetingData = () => {
    const sessionDurationMinutes =
      formData.sessionDuration === "500.00" ? 40 : 60;
    const sessionStartTime = convertTo24Hour(formData.sessionTime);
    const startDateTime = new Date(
      `${formData.sessionDate}T${sessionStartTime}`
    ).toISOString();
    const endDateTime = addMinutesToTime(startDateTime, sessionDurationMinutes);

    const description = `Your 1:1 Counselling Session (${sessionDurationMinutes} minutes) has been Successfully Scheduled`.trim();

    return {
      summary: `${formData.name}:${sessionDurationMinutes} Minutes Counselling Session | Mento`,
      description: description,
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      attendees: [
        formData.email,
      ],
      timezone: "Asia/Kolkata",
      sendNotification: true,
      location: "Online Video Call - Link will be shared via email",
    };
  };

  // Function to schedule meeting after successful payment
  const scheduleMeeting = async () => {
    try {
      console.log("Scheduling meeting...");
      const meetingData = createMeetingData();

      const result = await meetAndMail(meetingData);
      console.log("Meeting scheduled successfully:", result);

      return result;
    } catch (error) {
      console.error("Failed to schedule meeting:", error);
      // Don't throw error - we don't want to stop the form flow if meeting creation fails
      // Just log it and maybe show a warning to the user

    }
  };

  const validatePhoneNumber = (phone) => {
    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");

    // Check if it's exactly 10 digits
    if (cleaned.length !== 10) {
      return false;
    }

    // Check if it doesn't start with 0 (Indian mobile numbers don't start with 0)
    if (cleaned.startsWith("0")) {
      return false;
    }

    return true;
  };

  // Profession options
  const professionOptions = [
    "Student",
    "Professional",
    "Self-employed",
    "Homemaker",
    "Retired",
    "Unemployed",
    "Other",
  ];

  // Feelings reason options
  const feelingsReasonOptions = [
    "Work-related stress",
    "Family issues",
    "Academic pressure",
    "Financial concerns",
    "Health issues",
    "Personal loss",
    "Relationship difficulties",
    "Identity/self-esteem issues",
    "Past trauma",
    "Other",
  ];

  // Social media platforms for referral
  const referralOptions = [
    "Instagram",
    "Facebook",
    "Twitter",
    "LinkedIn",
    "Google Search",
    "YouTube",
    "Friend/Family",
    "Healthcare provider",
    "Other",
  ];

  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");

    // Limit to 10 digits
    const limited = cleaned.slice(0, 10);

    return limited;
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let processedValue = value;

    // Format phone numbers
    if (name === "contactNo" || name === "guardianContactNo") {
      processedValue = formatPhoneNumber(value);
    }

    // Update state for form data
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : processedValue,
    });

    // Clear error for this field when user types
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  // Handle dropdown selection changes
  const handleDropdownChange = (e) => {
    const { name, value } = e.target;

    // Update state for form data
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field when user selects
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  // Handle radio selection changes
  const handleRadioChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field when user selects
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  // Validate current step
  const validateStep = () => {
    const newErrors = {};

    // Step 1 validation
    if (currentStep === 1) {
      if (!formData.name || !formData.name.trim())
        newErrors.name = "Name is required";
      if (!formData.email || !formData.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email is invalid";
      }
      if (!formData.city || !formData.city.trim())
        newErrors.city = "City is required";

      // Updated contact number validation
      if (!formData.contactNo || !formData.contactNo.trim()) {
        newErrors.contactNo = "Contact number is required";
      } else if (!validatePhoneNumber(formData.contactNo)) {
        newErrors.contactNo = "Please enter a valid 10-digit phone number";
      }

      // Updated guardian contact number validation
      if (!formData.guardianContactNo || !formData.guardianContactNo.trim()) {
        newErrors.guardianContactNo = "Guardian contact number is required";
      } else if (!validatePhoneNumber(formData.guardianContactNo)) {
        newErrors.guardianContactNo =
          "Please enter a valid 10-digit phone number";
      }

      if (!formData.age) newErrors.age = "Age is required";
      if (!formData.gender) newErrors.gender = "Gender is required";
      if (!formData.profession) newErrors.profession = "Profession is required";
    }

    // Step 2 validation
    if (currentStep === 2) {
      if (!formData.supportReason || formData.supportReason.length === 0) {
        newErrors.supportReason = "Please select at least one reason";
      } else if (
        formData.supportReason.includes("Other") &&
        (!formData.otherSupportReason || !formData.otherSupportReason.trim())
      ) {
        newErrors.otherSupportReason = "Please specify your reason";
      }
    }

    // Step 3 validation
    else if (currentStep === 3) {
      if (!formData.feelingsReason)
        newErrors.feelingsReason = "Please select a reason";
      if (!formData.previousConsultation)
        newErrors.previousConsultation = "Please select an option";
      if (!formData.preferredLanguage) {
        newErrors.preferredLanguage = "Please select a language";
      } else if (
        formData.preferredLanguage === "Other" &&
        (!formData.otherLanguage || !formData.otherLanguage.trim())
      ) {
        newErrors.otherLanguage = "Please specify your language";
      }
    }

    // Step 4 validation
    else if (currentStep === 4) {
      if (!formData.counselorGenderPreference)
        newErrors.counselorGenderPreference = "Please select an option";
      if (!formData.medicalConditions)
        newErrors.medicalConditions = "Please select an option";
      if (!formData.referralSource)
        newErrors.referralSource = "Please select an option";
      if (!formData.termsAgreed)
        newErrors.termsAgreed = "You must agree to the terms";
      if (!formData.PaymentsAgreed)
        newErrors.termsAgreed = "You must agree to the terms";
    }

    // Step 5 validation
    else if (currentStep === 5) {
      if (!formData.sessionDuration) {
        newErrors.sessionDuration = "Please select a session duration";
      }
      if (!formData.sessionDate) newErrors.sessionDate = "Please select a date";
      if (!formData.sessionTime)
        newErrors.sessionTime = "Session time is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //Auto-next functionality using useEffect
  useEffect(() => {
    // Helper function to check if step is complete without showing errors
    const isStepComplete = () => {
      switch (currentStep) {
        case 1:
          return (
            formData.name &&
            formData.email &&
            /\S+@\S+\.\S+/.test(formData.email) &&
            formData.city &&
            formData.contactNo &&
            validatePhoneNumber(formData.contactNo) &&
            formData.guardianContactNo &&
            validatePhoneNumber(formData.guardianContactNo) &&
            formData.age &&
            formData.gender &&
            formData.profession
          );
        case 2:
          return false; // This prevents auto-next for step 2
        case 3:
          if (!formData.feelingsReason || !formData.previousConsultation)
            return false;
          if (!formData.preferredLanguage) return false;
          if (formData.preferredLanguage === "Other" && !formData.otherLanguage)
            return false;
          return true;
        case 4:
          return (
            formData.counselorGenderPreference &&
            formData.medicalConditions &&
            formData.referralSource &&
            formData.termsAgreed &&
            formData.PaymentsAgreed
          );
        case 5:
          if (!formData.sessionDuration) return false;
          if (!formData.sessionDate) return false;
          if (!formData.sessionTime) return false;
          return true;
        default:
          return false;
      }
    };

    // Only trigger auto-next for steps 1 to 6 when fields are complete (excluding step 2)
    if (
      currentStep < 4 &&
      currentStep !== 2 &&
      autoNextEnabled &&
      isStepComplete()
    ) {
      const timer = setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
      }, 300); // Small delay for better UX

      return () => clearTimeout(timer);
    }
  }, [formData, currentStep, autoNextEnabled]);

  // Move to next step
  const nextStep = () => {
    // Mark current step as attempted
    setStepsAttempted((prev) => ({
      ...prev,
      [currentStep]: true,
    }));

    // Always validate before moving to next step
    if (validateStep()) {
      // Check if we're going to step 2
      if (currentStep === 1) {
        // If we're moving to step 2, disable auto-next
        setAutoNextEnabled(false);
      }

      if (currentStep < totalSteps) {
        setCurrentStep(currentStep + 1);

        // Only enable auto-next when not going to step 2
        if (currentStep !== 1) {
          setAutoNextEnabled(true);
        }
      }
    } else {
      // Scroll to the first error field
      const firstErrorField = document.querySelector(".error-message-MN");
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  // Move to previous step
  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setAutoNextEnabled(false); // Disable auto-next when going back
    }
  };
  const sessionTimeExtractor = (start, end) => {
    const starttime = new Date(start);
    const endtime = new Date(end);

    // Format to hour + AM/PM
    const startHour = starttime.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    const endHour = endtime.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${startHour} - ${endHour}`;
  };

  // Updated handle_final_submit with meeting scheduling
  // const handle_final_submit = async (e) => {
  //   e.preventDefault();
  //   console.log("Form data submitted successfully:", database_response);

  //   try {
  //     if (formData.sessionDuration) {
  //       const mail_response = await meetAndMail(createMeetingData());

  //       console.log("Mail response:", mail_response);
  //       console.log();
  //     
  //       const mail_body = {
  //         ...mail_response.data,
  //         ...formData
  //       }
  //      

  //       ThankYouStep(formData);
  //     } else {
  //       alert("Please select a session duration before proceeding to payment.");
  //     }
  //   } catch (error) {
  //     console.error("Error in final submit:", error);

  //   }
  // };

  const handle_final_submit = async (e) => {
    e.preventDefault();

    try {
      if (formData.sessionDuration) {
          const data= createMeetingData();
        
           const updatebody = {

          id: database_response.data.id,
          sessionTime: sessionTimeExtractor(
            data.startDateTime,
            data.endDateTime
          )}
          await putData('/individual', updatebody)
         const mail_response = await meetAndMail(createMeetingData());
            const mail_data = {
              ...formData,
              ...mail_response.data,
              ...updatebody

            }
            sessionStorage.setItem('bookingDataForEmail', JSON.stringify(mail_data))

            // console.log('start')
            // const response = await mailforthemeet(mail_data)
            // console.log('end')
            
          prod_aws_payment(formData).then(async (res) => {
          if (true) {
            ThankYouStep();
        };
          }
        )
          .catch((err) => {
          });
          setCurrentStep(6); // Or whatever step number you want for the thank you page
      }
    else {
      alert("Please select a session duration before proceeding to payment.");
    }
  } catch (error) {
    console.error("Error in final submit:", error);
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();
  if (validateStep()) {
    try {
      formData.submittedAt = new Date().toISOString();
      formData.paymentstatus = "Pending";

      await handle_service(formData, "individual").then((res) => {
          // Fire conversion tracking after successful service call
          if (typeof window.gtag !== "undefined") {
            window.gtag("event", "conversion", {
              send_to: "AW-17319920929/ChSlCNapwesaEKGK5MJA",
            });
            setdatabase_response(res);
          }
        });

    

      nextStep();
    } catch (error) {
      // Show more detailed error message
      let errorMessage = "Failed to schedule your consultation. ";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage += error.response.data.message;
      } else if (error.message) {
        errorMessage += error.message;
      } else {
        errorMessage += "Please try again later.";
      }

      alert(errorMessage);
    }
  }
};

const handleSupportReasonChange = (option) => {
  const currentSelections = [...formData.supportReason];
  if (currentSelections.includes(option)) {
    // Remove option if already selected
    const updatedSelections = currentSelections.filter(
      (item) => item !== option
    );
    setFormData({
      ...formData,
      supportReason: updatedSelections,
    });
  } else {
    // Add option if not already selected
    setFormData({
      ...formData,
      supportReason: [...currentSelections, option],
    });
  }

  // Clear error when user selects options
  if (errors.supportReason) {
    setErrors((prev) => ({ ...prev, supportReason: null }));
  }
};

const generateTimeSlots = (selectedDate) => {
  const slots = [];
  const now = new Date();
  const today = new Date();
  const selectedDateObj = selectedDate ? new Date(selectedDate) : null;

  // Base time range: 10:30 AM to 10:30 PM
  const startTime = new Date();
  startTime.setHours(10, 30, 0, 0); // 10:30 AM

  const endTime = new Date();
  endTime.setHours(22, 30, 0, 0); // 10:30 PM

  // If no date selected, return empty array
  if (!selectedDateObj) {
    return [];
  }

  // Check if selected date is today
  const isToday = selectedDateObj.toDateString() === today.toDateString();

  // Check if selected date is in the future
  const isFutureDate = selectedDateObj > today;

  // If it's today, apply the 3-hour rule and 8:30 PM cutoff
  if (isToday) {
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();

    // If current time is after 8:30 PM, return empty array (no slots available)
    if (currentHour > 20 || (currentHour === 20 && currentMinutes >= 30)) {
      return [];
    }

    // Calculate minimum start time (current time + 3 hours)
    const minStartTime = new Date(now);
    minStartTime.setHours(minStartTime.getHours() + 3);

    // If minimum start time is after 10:30 PM, no slots available
    if (minStartTime > endTime) {
      return [];
    }

    // Start generating slots from the next available 30-minute interval after minStartTime
    const current = new Date(startTime);

    while (current <= endTime) {
      // Only include slots that are at or after the minimum start time
      if (current >= minStartTime) {
        const timeString = current.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });

        slots.push({
          value: timeString,
          label: timeString,
        });
      }

      // Add 30 minutes
      current.setMinutes(current.getMinutes() + 30);
    }
  }
  // If it's a future date, show all slots
  else if (isFutureDate) {
    const current = new Date(startTime);

    while (current <= endTime) {
      const timeString = current.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      slots.push({
        value: timeString,
        label: timeString,
      });

      // Add 30 minutes
      current.setMinutes(current.getMinutes() + 30);
    }
  }
  // If it's yesterday or past date, return empty array
  else {
    return [];
  }

  return slots;
};

// Helper function to get user-friendly message when no slots are available
const getNoSlotsMessage = (selectedDate) => {
  if (!selectedDate) {
    return "Please select a date first to see available time slots";
  }

  const selectedDateObj = new Date(selectedDate);
  const today = new Date();
  const now = new Date();

  const isToday = selectedDateObj.toDateString() === today.toDateString();
  const isPastDate = selectedDateObj < today;

  if (isPastDate) {
    return "Past dates are not available for booking. Please select today or a future date.";
  }

  if (isToday) {
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();

    // If current time is after 8:30 PM
    if (currentHour > 20 || (currentHour === 20 && currentMinutes >= 30)) {
      return "No slots available for today after 8:30 PM. Please choose tomorrow's date for available slots.";
    }

    // If current time + 3 hours exceeds 10:30 PM
    const minStartTime = new Date(now);
    minStartTime.setHours(minStartTime.getHours() + 3);
    const endTime = new Date();
    endTime.setHours(22, 30, 0, 0);

    if (minStartTime > endTime) {
      return "No slots available for today as booking requires 3 hours advance notice. Please choose tomorrow's date for available slots.";
    }
  }

  return "No slots available for the selected date.";
};

// Step indicator component
const StepIndicator = ({ number, title, subtitle, active }) => (
  <div className={`step-indicator-MN ${active ? "active" : ""}`}>
    <div className="step-number-MN">{number}</div>
    <div className="step-text-MN">
      <p className="step-subtitle-MN">{subtitle}</p>
      <p className="step-title-MN">{title}</p>
    </div>
  </div>
);

const renderError = (fieldName) => {
  if (errors[fieldName]) {
    return <p className="error-message-MN">{errors[fieldName]}</p>;
  }
  return null;
};

// Render different form steps
const renderStep = () => {
  switch (currentStep) {
    case 1:
      return (
        <div className="form-step-MN form-step-1-MN">
          <h2 className="form-title-MN">Personal Information</h2>
          <p className="form-subtitle-MN">
            Please provide your personal details for the consultation.
          </p>

          <div className="oneLineDetail">
            <div className="form-field-MN fieldWidthName">
              <label>
                Full Name <span className="required-field">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g. John Smith"
                className={errors.name ? "error-input" : ""}
              />
              {renderError("name")}
            </div>

            <div className="form-field-MN fieldWidthEmail">
              <label>
                Email Address <span className="required-field">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="e.g. johnsmith@example.com"
                className={errors.email ? "error-input" : ""}
              />
              {renderError("email")}
            </div>
          </div>

          <div className="oneLineDetail">
            <div className="form-field-MN fieldWidthCity">
              <label>
                City <span className="required-field">*</span>
              </label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="e.g. Bangalore"
                className={errors.city ? "error-input" : ""}
              />
              {renderError("city")}
            </div>

            <div className="form-field-MN fieldWidthAge">
              <label>
                Age <span className="required-field">*</span>
              </label>
              <input
                type="number"
                name="age"
                value={formData.age}
                onChange={handleChange}
                placeholder="e.g. 30"
                min="1"
                max="120"
                className={errors.age ? "error-input" : ""}
              />
              {renderError("age")}
            </div>

            <div className="form-field-MN fieldWidthAge">
              <label>
                Gender <span className="required-field">*</span>
              </label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleDropdownChange}
                className={errors.gender ? "error-input" : ""}
              >
                <option value="" disabled>
                  Select gender
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Prefer not to say">Prefer not to say</option>
              </select>
              {renderError("gender")}
            </div>
          </div>

          <div className="oneLineDetail">
            <div className="form-field-MN fieldWidthNo">
              <label>
                Contact Number <span className="required-field">*</span>
              </label>
              <input
                type="tel"
                name="contactNo"
                value={formData.contactNo}
                onChange={handleChange}
                placeholder="e.g. +91 9876543210"
                className={errors.contactNo ? "error-input" : ""}
              />
              {renderError("contactNo")}
            </div>

            <div className="form-field-MN fieldWidthNo">
              <label>
                Guardian's Contact Number{" "}
                <span className="required-field">*</span>
              </label>
              <input
                type="tel"
                name="guardianContactNo"
                value={formData.guardianContactNo}
                onChange={handleChange}
                placeholder="e.g. 9876543210"
                className={errors.guardianContactNo ? "error-input" : ""}
                maxLength="10"
              />
              {renderError("guardianContactNo")}
            </div>
          </div>

          <div className="form-field-MN fieldWidthPro">
            <label>
              Profession <span className="required-field">*</span>
            </label>
            <select
              name="profession"
              value={formData.profession}
              onChange={handleDropdownChange}
              className={errors.profession ? "error-input" : ""}
            >
              <option value="" disabled>
                Select your profession
              </option>
              {professionOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {renderError("profession")}
          </div>
        </div>
      );
    case 2:
      return (
        <div className="form-step-MN form-step-2-MN">
          <h2 className="form-title-MN">Support Reason</h2>
          <p className="form-subtitle-MN">
            What are the main reasons you're seeking mental wellness support?
            (Select all that apply) <span className="required-field">*</span>
          </p>

          <div className="form-field-MN">
            <div
              className={`radio-group-MNI ${errors.supportReason ? "error-border" : ""
                }`}
            >
              {[
                "Stress and anxiety",
                "Depression",
                "Relationship issues",
                "Work-life balance",
                "Grief and loss",
                "Trauma/PTSD",
                "Other",
              ].map((option) => (
                <div
                  key={option}
                  className={`radio-option-MN ${formData.supportReason.includes(option) ? "selected" : ""
                    }`}
                  onClick={() => handleSupportReasonChange(option)}
                >
                  <div className="radio-circle-MN">
                    {formData.supportReason.includes(option) && (
                      <div className="radio-dot-MN"></div>
                    )}
                  </div>
                  <span>{option}</span>
                </div>
              ))}
            </div>
            {renderError("supportReason")}
          </div>

          {formData.supportReason.includes("Other") && (
            <div className="form-field-MN">
              <label>
                Please specify your reason{" "}
                <span className="required-field">*</span>
              </label>
              <textarea
                name="otherSupportReason"
                value={formData.otherSupportReason}
                onChange={handleChange}
                placeholder="Please describe your reason for seeking support..."
                rows="2"
                className={errors.otherSupportReason ? "error-input" : ""}
              ></textarea>
              {renderError("otherSupportReason")}
            </div>
          )}
        </div>
      );
    case 3:
      return (
        <div className="form-step-MN form-step-3-MN">
          <h2 className="form-title-MN">Additional Information</h2>
          <p className="form-subtitle-MN">
            Please provide more details about your situation.
          </p>

          <div className="form-field-MN">
            <label>
              What is the reason behind your feelings (if identified)?{" "}
              <span className="required-field">*</span>
            </label>
            <select
              name="feelingsReason"
              value={formData.feelingsReason}
              onChange={handleDropdownChange}
              className={errors.feelingsReason ? "error-input" : ""}
            >
              <option value="" disabled>
                Select a reason
              </option>
              {feelingsReasonOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {renderError("feelingsReason")}
          </div>

          <div className="form-field-MN">
            <p className="form-label-MN">
              Have you previously consulted with a mental health professional?{" "}
              <span className="required-field">*</span>
            </p>
            <div
              className={`radio-group-MNI ${errors.previousConsultation ? "error-border" : ""
                }`}
            >
              {["Yes", "No"].map((option) => (
                <div
                  key={option}
                  className={`radio-option-MN ${formData.previousConsultation === option ? "selected" : ""
                    }`}
                  onClick={() =>
                    handleRadioChange("previousConsultation", option)
                  }
                >
                  <div className="radio-circle-MN">
                    {formData.previousConsultation === option && (
                      <div className="radio-dot-MN"></div>
                    )}
                  </div>
                  <span>{option}</span>
                </div>
              ))}
            </div>
            {renderError("previousConsultation")}
          </div>

          <div className="form-field-MN">
            <p className="form-label-MN">
              Language Preference <span className="required-field">*</span>
            </p>
            <div className="form-field-MN">
              <select
                name="preferredLanguage"
                value={formData.preferredLanguage}
                onChange={handleChange}
                className={`dropdown-MN ${errors.preferredLanguage ? "error-input" : ""
                  }`}
              >
                <option value="">Select a language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Kannada">Kannada</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Bengali">Bengali</option>
                <option value="Marathi">Marathi</option>
                <option value="Other">Other</option>
              </select>
              {renderError("preferredLanguage")}
            </div>

            {formData.preferredLanguage === "Other" && (
              <div className="form-field-MN">
                <label>
                  Please specify your preferred language{" "}
                  <span className="required-field">*</span>
                </label>
                <input
                  type="text"
                  name="otherLanguage"
                  value={formData.otherLanguage}
                  onChange={handleChange}
                  placeholder="e.g. Punjabi"
                  className={errors.otherLanguage ? "error-input" : ""}
                />
                {renderError("otherLanguage")}
              </div>
            )}
          </div>
        </div>
      );

    case 4:
      return (
        <div className="form-step-MN form-step-6-MN">
          <h2 className="form-title-MN">SUBMISSION</h2>
          <p className="form-subtitle-MN">
            Tell us more about your preferences for the consultation.
          </p>

          <div className="form-field-MN">
            <p className="form-label-MN">
              Do you have a preference for the gender of the counselor?{" "}
              <span className="required-field">*</span>
            </p>
            <div
              className={`radio-group-MNIM radio-group-row ${errors.counselorGenderPreference ? "error-border" : ""
                }`}
            >
              {["Male", "Female", "No preference"].map((option) => (
                <div
                  key={option}
                  className={`radio-option-MN OneLineOptions ${formData.counselorGenderPreference === option
                      ? "selected"
                      : ""
                    }`}
                  onClick={() =>
                    handleRadioChange("counselorGenderPreference", option)
                  }
                >
                  <div className="radio-circle-MN">
                    {formData.counselorGenderPreference === option && (
                      <div className="radio-dot-MN"></div>
                    )}
                  </div>
                  <span>{option}</span>
                </div>
              ))}
            </div>
            {renderError("counselorGenderPreference")}
          </div>

          <div className="form-field-MN">
            <p className="form-label-MN">
              Are you currently experiencing any medical conditions or taking
              medications for mental health?{" "}
              <span className="required-field">*</span>
            </p>
            <div
              className={`radio-group-MNIM  ${errors.medicalConditions ? "error-border" : ""
                }`}
            >
              {["Yes", "No", "Prefer not to say"].map((option) => (
                <div
                  key={option}
                  className={`radio-option-MN ${formData.medicalConditions === option ? "selected" : ""
                    }`}
                  onClick={() =>
                    handleRadioChange("medicalConditions", option)
                  }
                >
                  <div className="radio-circle-MN">
                    {formData.medicalConditions === option && (
                      <div className="radio-dot-MN"></div>
                    )}
                  </div>
                  <span>{option}</span>
                </div>
              ))}
            </div>
            {renderError("medicalConditions")}
          </div>

          <div className="form-field-MN fieldWidthHear">
            <label>
              How did you hear about our platform?{" "}
              <span className="required-field">*</span>
            </label>
            <select
              name="referralSource"
              value={formData.referralSource}
              onChange={handleDropdownChange}
              className={errors.referralSource ? "error-input" : ""}
            >
              <option value="" disabled>
                Select an option
              </option>
              {referralOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {renderError("referralSource")}
          </div>

          <div className="form-field-MN terms-container-MN">
            <label className="terms-label-MN">
              <span className="terms-text-Pay">
                <input
                  type="checkbox"
                  name="PaymentsAgreed"
                  checked={formData.PaymentsAgreed}
                  onChange={handleChange}
                  className={errors.PaymentsAgreed ? "error-input" : ""}
                />{" "}
               I understand that this conversation with the expert is a starting point, and progress may happen gradually over time. (session starting
                from ₹499/-)
              </span>
            </label>
            {renderError("PaymentsAgreed")}
          </div>

          <div className="form-field-MN terms-container-MN">
            <label className="terms-label-MN">
              <span className="terms-text-MN">
                <input
                  type="checkbox"
                  name="termsAgreed"
                  checked={formData.termsAgreed}
                  onChange={handleChange}
                  className={errors.termsAgreed ? "error-input" : ""}
                />{" "}
                I hereby give my informed consent for the release of written
                and/or verbal information related to my confidential file in
                case of threat to myself, or others. I agree to accept and
                follow the rules of time and regularity needed for the
                counseling. It is my understanding that the Counselor will
                maintain professional responsibility towards me.
              </span>
            </label>
            {renderError("termsAgreed")}
          </div>
        </div>
      );
    case 5:
      const timeSlots = generateTimeSlots(formData.sessionDate);
      const noSlotsMessage =
        timeSlots.length === 0
          ? getNoSlotsMessage(formData.sessionDate)
          : null;

      return (
        <div className="form-step-MN form-step-7-MN">
          <h2 className="form-title-MN">Session Selection</h2>
          <p className="form-subtitle-MN">
            Choose your preferred session time and duration.
          </p>

          <div className="form-field-MN">
            <input
              type="date"
              name="sessionDate"
              value={formData.sessionDate}
              onChange={(e) => {
                handleChange(e);
                // Clear selected time when date changes to force reselection
                setFormData((prev) => ({
                  ...prev,
                  sessionTime: "",
                }));
              }}
              min={new Date().toISOString().split("T")[0]} // Prevent past dates
              className={errors.sessionDate ? "error-input" : ""}
            />
            {renderError("sessionDate")}
          </div>

          <div className="form-field-MN">
            <p className="form-label-MN">
              Preferred time for the session{" "}
              <span className="required-field">*</span>
            </p>

            {!formData.sessionDate ? (
              <div className="time-slots-placeholder">
                <p
                  style={{
                    color: "#666",
                    fontStyle: "italic",
                    textAlign: "center",
                    padding: "20px",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "8px",
                    border: "2px dashed #ddd",
                  }}
                >
                  Please select a date first to see available time slots
                </p>
              </div>
            ) : timeSlots.length === 0 ? (
              <div className="time-slots-placeholder">
                <p
                  style={{
                    color: "#e74c3c",
                    fontStyle: "italic",
                    textAlign: "center",
                    padding: "20px",
                    backgroundColor: "#fdf2f2",
                    borderRadius: "8px",
                    border: "2px dashed #e74c3c",
                  }}
                >
                  {noSlotsMessage}
                </p>
              </div>
            ) : (
              <div
                className={`time-slots-container ${errors.sessionTime ? "error-border" : ""
                  }`}
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                  gap: "10px",
                  marginTop: "10px",
                  padding: "10px",
                  border: errors.sessionTime
                    ? "2px solid #e74c3c"
                    : "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#fafafa",
                }}
              >
                {timeSlots.map((slot) => {
                  const isSelected = formData.sessionTime === slot.value;

                  return (
                    <div
                      key={slot.value}
                      className={`time-slot-box ${isSelected ? "selected" : ""
                        }`}
                      onClick={() => {
                        handleRadioChange("sessionTime", slot.value);
                      }}
                      style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        borderRadius: "6px",
                        border: isSelected
                          ? "2px solid #edb94d"
                          : "1px solid #ddd",
                        backgroundColor: isSelected ? "#fdf6e3" : "#fff",
                        color: isSelected ? "#edb94d" : "#333",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        fontSize: "14px",
                        fontWeight: isSelected ? "600" : "400",
                        transform: isSelected ? "scale(1.02)" : "scale(1)",
                        boxShadow: isSelected
                          ? "0 2px 8px rgba(237, 185, 77, 0.3)"
                          : "none",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.target.style.backgroundColor = "#f8f9fa";
                          e.target.style.borderColor = "#edb94d";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.target.style.backgroundColor = "#fff";
                          e.target.style.borderColor = "#ddd";
                        }
                      }}
                    >
                      {slot.label}
                    </div>
                  );
                })}
              </div>
            )}

            {renderError("sessionTime")}

            {formData.sessionDate && timeSlots.length > 0 && (
              <p
                className="time-slot-info"
                style={{
                  fontSize: "0.9em",
                  color: "#666",
                  marginTop: "8px",
                }}
              >
                {(() => {
                  const selectedDate = new Date(formData.sessionDate);
                  const today = new Date();

                  if (selectedDate.toDateString() === today.toDateString()) {
                    return "* Showing available slots";
                  } else {
                    return "* All time slots are available for future dates";
                  }
                })()}
              </p>
            )}
          </div>

          <div className="form-field-MN">
            <p className="form-label-MN">
              Choose your session duration:{" "}
              <span className="required-field">*</span>
            </p>
            <div
              className={`radio-group-MNIM ${errors.sessionDuration ? "error-border" : ""
                }`}
            >
              {[
                {
                  value: "500.00",
                  label: "40 minute session",
                  price: "₹500.00",
                },
                {
                  value: "800.00",
                  label: "60 minute session",
                  price: "₹800.00",
                },
              ].map((option) => (
                <div
                  key={option.value}
                  className={`radio-option-MN ${formData.sessionDuration === option.value
                      ? "selected"
                      : ""
                    }`}
                  onClick={() =>
                    handleRadioChange("sessionDuration", option.value)
                  }
                >
                  <div className="radio-circle-MN">
                    {formData.sessionDuration === option.value && (
                      <div className="radio-dot-MN"></div>
                    )}
                  </div>
                  <span>{option.label}</span>
                </div>
              ))}
            </div>
            {renderError("sessionDuration")}
          </div>

          {formData.sessionDuration ? (
            <div className="pricing-info-MN">
              <h3>Consultation Fee</h3>
              <p className="fee-MN">
                {formData.sessionDuration === "500.00"
                  ? "₹500.00"
                  : "₹800.00"}
              </p>
              <p className="fee-description-MN">
                {formData.sessionDuration === "500.00"
                  ? "40-minute online counselling session"
                  : "60-minute  online counselling session"}
              </p>
              <p className="note-MN">
                * Additional sessions may be recommended based on initial
                counselling.
              </p>
            </div>
          ) : (
            <div className="pricing-info-MN empty-pricing">
              <p className="select-prompt">
                Please choose a session duration to see the counselling fee.
              </p>
            </div>
          )}
        </div>
      );
    case 6:
      return (
        <div className="form-step-MN form-step-8-MN">
          <div className="payment-loading-MN">
            <div className="loading-spinner-MN">
              <div className="spinner"></div>
            </div>
            <h2 className="form-title-MN">Processing Payment</h2>
            <p className="form-subtitle-MN">
              Please wait while we process your payment...
            </p>

            <div className="processing-details-MN">
              <p>
                Transaction for:{" "}
                <strong>
                  {formData.service || "Mental Wellness Consultation"}
                </strong>
              </p>
              <p>
                Amount: <strong>₹{formData.sessionDuration}</strong>
              </p>
              <p>
                This may take a few moments. Please do not refresh or close
                this page.
              </p>
            </div>

            <div className="security-info-MN">
              <h3>Secure Transaction</h3>
              <p>Your payment information is encrypted and secure.</p>
            </div>

            <div className="contact-info-MN">
              <p>
                If you experience any issues with your payment, please contact
                us at:
              </p>
              <p>
                <strong>connect@mento.in</strong> or call{" "}
                <strong>+91 9120719120</strong>
              </p>
            </div>
          </div>
          <ThankYouStep formData={formData} />
        </div>
      );
    default:
      return null;
  }
};

return (
  <>
    <div className="multi-step-form-MN">
      {/* Left sidebar with steps */}
      <div className="sidebar-MN">
        <div className="steps-container-MN">
          <StepIndicator
            number="1"
            subtitle="Step 1"
            title="PERSONAL INFO"
            active={currentStep === 1}
          />
          <StepIndicator
            number="2"
            subtitle="Step 2"
            title="SUPPORT REASON"
            active={currentStep === 2}
          />
          <StepIndicator
            number="3"
            subtitle="Step 3"
            title="ADDITIONAL INFO"
            active={currentStep === 3}
          />
          <StepIndicator
            number="4"
            subtitle="Step 4"
            title="SUBMISSION"
            active={currentStep === 4}
          />
          <StepIndicator
            number="5"
            subtitle="Step 5"
            title="SCHEDULING & PAYMENT"
            active={currentStep === 5}
          />
          <StepIndicator
            number="6"
            subtitle="Step 6"
            title="CONFIRMATION"
            active={currentStep === 6}
          />
        </div>

        {/* Decorative circles */}
        <div className="decorative-circles-MN">
          <div className="circle-1-MN"></div>
          <div className="circle-2-MN"></div>
        </div>
      </div>

      {/* Right content area */}
      <div className="form-container-MN">
        <form onSubmit={handleSubmit}>
          <div className="form-content-MN">{renderStep()}</div>

          <div className="form-buttons-MN">
            {currentStep > 1 && currentStep < 5 && (
              <button
                type="button"
                onClick={prevStep}
                className="back-button-MN"
              >
                Go Back
              </button>
            )}
            {currentStep < 4 ? (
              <button
                type="button"
                onClick={nextStep}
                className="next-button-MN"
              >
                Next Step
              </button>
            ) : currentStep === 4 ? (
              <button
                type="button"
                onClick={async (e) => {
                  await handleSubmit(e); // Call handleSubmit first
                  if (Object.keys(errors).length === 0) {
                    nextStep(); // Only proceed to next step if validation passes
                  }
                }}
                className="confirm-button-final"
              >
                Submit
              </button>
            ) : currentStep === 5 ? (
              <>
                <button
                  type="button"
                  onClick={() =>
                    window.open("https://wa.me/+919120719120", "_blank")
                  }
                  className="confirm-button-MN support-button hover-scale"
                >
                  <div
                    className="button-content"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={whatsappIcon}
                      alt="WhatsApp"
                      style={{
                        width: "25px",
                        height: "25px",
                        marginRight: "8px",
                      }}
                    />
                    <span>Need Support?</span>
                  </div>
                </button>
                <button
                  type="button"
                  onClick={(e) => {
                    if (validateStep()) {
                      // Validate before proceeding
                      handle_final_submit(e);
                      nextStep();
                    }
                  }}
                  className="confirm-button-MN"
                >
                  Confirm & Pay
                </button>
              </>
            ) : currentStep === 6 ? (
              <button
                type="button"
                onClick={() => (window.location.href = "/")}
                className="dashboard-button-MN"
              >
                Go to Home
              </button>
            ) : null}
          </div>
        </form>
      </div>
    </div>
  </>
);
};

export default FamilyTherapyForm;
